import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English" },
  { code: "pl", label: "Polski" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = languages.find((l) => l.code === i18n.language) ?? languages[0];

  const change = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:bg-background-100"
        aria-label="Change language"
      >
        <i className="ri-global-line text-base"></i>
      </button>

      {open && (
        <div className="absolute right-0 top-11 z-50 w-40 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => change(l.code)}
              className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-2 text-sm transition-colors hover:bg-background-100 ${
                l.code === current.code ? "text-primary-600 font-semibold" : "text-foreground-700"
              }`}
            >
              <span>{l.label}</span>
              {l.code === current.code && <i className="ri-check-line text-sm"></i>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}